import * as React from 'react';

import { cn } from '@/utils';

const CheckIcon = () => (
  <svg
    className="w-3 h-3 text-underwater-fern-green"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

interface DayCheckboxProps {
  day: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onSelect: (day: string) => void;
  keyPrefix: string;
}

export const DayCheckbox: React.FC<DayCheckboxProps> = ({
  day,
  isSelected,
  isDisabled = false,
  onSelect,
  keyPrefix,
}) => (
  <label
    key={`${keyPrefix}-${day}`}
    className={cn(
      'flex items-center cursor-pointer',
      isDisabled && 'opacity-50'
    )}
  >
    <div className="relative">
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => onSelect(day)}
        disabled={isDisabled}
        className="sr-only"
      />
      <div
        className={cn(
          'w-5 h-5 rounded border flex items-center justify-center transition-colors',
          isSelected
            ? 'bg-magical-moonlight-white border-underwater-fern-green'
            : 'border-magical-moonlight-m bg-magical-moonlight-white',
          isDisabled && 'opacity-50 cursor-not-allowed'
        )}
      >
        {isSelected ? <CheckIcon /> : null}
      </div>
    </div>
    <span
      className={cn(
        'ml-3 text-sm font-medium',
        isDisabled ? 'text-magical-moonlight-d1' : 'text-magical-moonlight-d3'
      )}
    >
      {day}
    </span>
  </label>
);
